/* eslint-disable no-undef */
/* eslint-disable camelcase */
/* eslint-disable import/named */
import { API_SECURITIES_GENERAL_URL } from 'constants/api';
import requestConfig from 'config/requestTrading';
import { APIPromiseResponse } from '../../../@types/api-response';

const request = requestConfig();

const STOCK_TRANSFER_URL = `${API_SECURITIES_GENERAL_URL}/stock-transfer`;

/**
 * Get securities login token
 * @return {APIResponse}
 */
const getStockTransferExist = (): APIPromiseResponse<IStockTransferExist> =>
  request.get(`${STOCK_TRANSFER_URL}/is-exist`);

const getTransactionList = (
  type: 'history' | 'transfer',
): APIPromiseResponse<Array<IStockTransferHistory>> =>
  request.get(`${STOCK_TRANSFER_URL}/transactions`, {
    params: {
      type,
    },
  });

const getTransactionDetail = (
  stockTransferId,
): APIPromiseResponse<IDetailStockTransferV2> =>
  request.get(`${STOCK_TRANSFER_URL}/v2/transactions/${stockTransferId}`);

// 1: All; 2: Default; 3: Others
const getSecuritiesList = (
  type = 2,
): APIPromiseResponse<Array<ISecuritiesItem>> =>
  request.get(`${STOCK_TRANSFER_URL}/securities`, {
    params: {
      query_type: type,
    },
  });

const getForm = (
  securityCode: string,
  transferId?: string,
): APIPromiseResponse<{ form: { data: IStockTransferForm } }> =>
  request.get(`${STOCK_TRANSFER_URL}/v2/form`, {
    params: {
      security_code: securityCode,
      stock_transfer_id: transferId,
    },
  });

const postTransaction = (
  data: ISaveStockTransfer,
): APIPromiseResponse<IStockTransferSave> =>
  request.post(`${STOCK_TRANSFER_URL}/v2/transactions`, {
    stock_transfer_data: data,
  });

const cancelTransaction = (
  stockTransferId,
): APIPromiseResponse<IStockTransferCancel> =>
  request.post(`${STOCK_TRANSFER_URL}/transactions/cancel`, {
    stock_transfer_id: stockTransferId,
  });

const getUploadToken = (
  securityCode: string,
): APIPromiseResponse<IStockTransferToken> =>
  request.get(`${STOCK_TRANSFER_URL}/upload/token`, {
    params: {
      security_code: securityCode,
    },
  });

const uploadImage = (url, body) =>
  fetch(url, {
    method: 'POST',
    body,
  });

const getNotification = (): APIPromiseResponse<IStockTransferNotification> =>
  request.get(`${STOCK_TRANSFER_URL}/notifications`);

export default {
  getStockTransferExist,
  getTransactionList,
  getTransactionDetail,
  getSecuritiesList,
  getForm,
  postTransaction,
  cancelTransaction,
  getUploadToken,
  uploadImage,
  getNotification,
};
